import './LoadedFreelance.scss';

import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { format } from 'date-fns';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge} from 'reactstrap';
import nl2br from 'react-nl2br';
import Linkedin from 'react-feather/dist/icons/linkedin.js';
import Copy from 'react-feather/dist/icons/copy.js';
import Share from 'react-feather/dist/icons/share-2.js';
import connect from 'react-redux/es/connect/connect';
import Tooltip from 'rc-tooltip';

import ContactModal from '../../../Modals/ContactModal/ContactModal.jsx';
import MomentDate from '../../../../../shared/components/Moment/Date.jsx';
import Picture from '../../../Picture/Picture.jsx';
import Loader from '../../../../../shared/components/Loader/Loader.jsx';
import Availability from '../Availability/Availability.jsx';
import Price from '../Price/Price.jsx';
import Skills from '../../../Skills/Skills.jsx';
import CompanyType from '../../../CompanyType/CompanyType.jsx';
import Labels from '../Labels/Labels.jsx';
import Mission from '../Missions/Mission.jsx';
import MissionSummary from '../Missions/MissionSummary.jsx';
import Review from '../Review/Review.jsx';
import SubscribeBanner from '../../../../components/SubscribeBanner/SubscribeBanner.jsx';

import api from '../../../../../api.js';
import connectModal from '../../../../../shared/components/Modals/connect.js';
import conf from '../../../../conf.js';
import {downloadFile} from '../../../../services/downloadService.js';
import sharedConf from '../../../../../shared/conf.js';

import LogoText from '../../../../media/svg/logo-twineeds.svg';
import Logo from '../../../../media/svg/logo.svg';
import AnonymizedImg from '../../../../media/svg/anonymized.svg';

import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx";
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx";
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

export class LoadedFreelance extends Component {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    className: PropTypes.string,
    expertisesTitle: PropTypes.string,
    secteursTitle: PropTypes.string,
    missionsTitle: PropTypes.string,
    missionsSummaryTitle: PropTypes.string,
    parcoursTitle: PropTypes.string,
    certificationsTitle: PropTypes.string,
    languagesTitle: PropTypes.string,
  };

  static defaultProps = {
    owner: false,
    isAdmin: false,
    className: '',
    expertisesTitle: 'Compétences confirmées',
    secteursTitle: 'Principaux secteurs',
    missionsTitle: 'Détail des missions',
    missionsSummaryTitle: 'Résumé des expériences',
    parcoursTitle: 'Formation',
    certificationsTitle: 'Certifications',
    languagesTitle: 'Langues',
    itSkillsTitle: 'Logiciels et outils informatiques',
  };

  constructor(props) {
    const urlParams = new URLSearchParams(window.location.search)
    super(props);
    if (!this.props.isAdmin) {
      document.body.oncopy = () => false;
      document.body.oncut = () => false;
    }
    this.state = {
      loading: false,
      anonymized: ['true', '1'].includes(urlParams.get('anonymized')),
      contactDropDownOpen: false,
      languageLevels: Object.values(conf.languageLevels).reduce(
        (acc, curr) => {
          acc[curr.value] = curr.label;
          return acc;
        },
        []
      )
    };
  }

  toggleContact = () => {
    this.setState({contactDropDownOpen: !this.state.contactDropDownOpen});
  };

  downloadCvNormalized = (anonymized = false) => {
    return api.freelances.cv.getNormalized({
      freelance: this.props.freelance.id,
      anonymized: anonymized || false
    })
      .then((blob) => {
        const firstname = this.props.user?.firstname ?? '';
        const freelanceId = this.props.freelance?.id ?? 0;
        const dateFormatted = format(new Date(), 'yyyyMMdd');
        const name = `${dateFormatted}-CV_Twineeds-${firstname}-${freelanceId}`;
        return downloadFile(blob, name, 'pdf');
      })
      .catch((err) => console.warn(err));
  };

  onCvNormalizedDownloaded = async (anonymized = false) => {
    this.setState({loading: true});
    this.downloadCvNormalized(anonymized)
      .finally(() => {
        this.setState({loading: false});
      })
  };

  openContactModal = (user, freelance) => {
    this.props.openContactModal({
      user: user,
      freelance: freelance,
      onCvNormaliseDownloaded: this.downloadCvNormalized,
    });
  };

  handleCopy = (e) => {
    e.preventDefault();
  };

  copyEmailToClipboard = async() => {
    await navigator.clipboard.writeText(this.props?.user.email ?? '');
  };

  formatTel = (tel) => {
    const hasInternationalPrefix = tel.startsWith('+');
    const regex = hasInternationalPrefix ? /(\+\d{2})(\d)(\d{2})(\d{2})(\d{2})(\d+)/ : /(\d{2})(\d{2})(\d{2})(\d{2})(\d+)/;
    const format = hasInternationalPrefix ? "$1 $2 $3 $4 $5 $6" : "$1 $2 $3 $4 $5";

    return tel.replace(regex, format);
  };

  copyTelToClipboard = async() => {
    await navigator.clipboard.writeText(this.props?.user.tel ?? '');
  };

  copyFullnameToClipboard = async() => {
    await navigator.clipboard.writeText(this.props?.user.fullname ?? '');
  };

  copyFreelanceProfileToClipboard = async() => {

    const currentLocation = window.location
    const freelanceLink = this.props.generate({
      name: 'freelance-profile',
      parameters: {
        slug: this.props?.freelance?.slug ?? null,
      },
      search: null,
    })

    if(currentLocation.origin) {
      await navigator.clipboard.writeText(`${currentLocation.origin}${freelanceLink}`);
    }
  };

  currentUserCanView = () => {
    const currentUser = this.props?.currentUser ?? null
    const currentUserFreelanceId = currentUser?.freelance_id ?? null
    const profileFreelanceId = this.props?.freelance.id ?? null
    if(profileFreelanceId && currentUserFreelanceId && profileFreelanceId === currentUserFreelanceId) {
      return true
    }

    return currentUser
      ? (this.props.isOwner || this.props.isAdmin || (currentUser.account_type !== sharedConf.accountTypes.freelance))
      : false;
  }

  render() {
    const {
      generate,
      profile: {
        freelance,
        user,
        reviews,
        human_skills,
      },
      isAdmin,
      isOwner
    } = this.props;

    const currentUser = this.props?.currentUser ?? null;
    const currentUserCanView = this.currentUserCanView()

    const image = currentUserCanView ? user?.image?.square ?? null : null;
    const altImage = currentUserCanView ?
      `consultant conseil achats ${this.props?.freelance?.title ?? ''}` :
      currentUser ? 'Vous n\'avez pas accès aux photos des autres consultants en tant que Freelance' : 'Vous devez être connecté pour voir la photo des consultants';

    const isReviewed = this.props?.freelance?.is_reviewed ?? false;

    const title = freelance?.title ?? '';
    const description = 'Twineeds met en relation les meilleurs consultants des Achats / Supply Chain, '
      + 'des Ressources Humaines et de la Finance avec les entreprises.';

    return (
      <div className={this.props.className} onCopy={this.handleCopy} onCut={this.handleCopy} onPaste={this.handleCopy}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description}/>
          <meta property="og:description" content={description}/>
          <meta property="og:title" content={title}/>
        </Helmet>
        <Loader visible={!!this.state.loading}>Téléchargement du CV ...</Loader>
        <FreelancePage className={'fl-pages-profile'}>
          <div className="position-relative">
            <div className="row bordered print-no-margin">
              <div className="col-12">
                <div className="row header-twineeds print"> {/* ℹ️ Only for print */}
                  <div className="logo">
                    <Logo className="logoIcon"/>
                    <LogoText className="logoText"/>
                  </div>
                  <div className="info">
                  #talents #freedom #success
                  </div>
                </div>
                <div className="meeting text-center row bg-gray-100 justify-content-center print">{/* ℹ️ Only for print */}
                  <span className="meet">
                Rencontrez {user?.firstname ?? ''} au <a
                      href={`tel:${conf.site.phone}`}>{conf.site.phone}</a> ou par mail <a
                      href={`mailto:${conf.site.emails.contact}`}>{conf.site.emails.contact}</a>
                  </span>
                </div>
                {isAdmin &&
              <div className="row user-infos infos-admin top-rounded bg-gray-100">
                <Labels freelance={freelance} user={user}/>
                <div>
                  <strong>User ID : </strong> #{user?.id ?? ''}<br/>
                  <strong>Freelance ID : </strong> #{freelance?.id ?? ''}
                </div>
                <div>
                  <div className="d-flex align-items-center">
                    <strong>E-mail : </strong> {user?.email ?? 'Pas d\'e-mail'}
                    {isAdmin ? <Copy className="copy no-print" size={20} onClick={this.copyEmailToClipboard}/> : '' }
                  </div>
                  <div>
                    <strong>Téléphone : </strong>
                    <span>{this.formatTel(user?.tel ?? 'Pas de téléphone')}</span>
                    {isAdmin ? <Copy className="copy no-print" size={20} onClick={this.copyTelToClipboard}/> : '' }
                  </div>
                </div>
                {generate &&
                <div>
                  <Tooltip placement="top" overlay={'Copier le lien du profil'}>
                    <Share className="copy no-print" size={20} onClick={this.copyFreelanceProfileToClipboard}/>
                  </Tooltip>
                </div>}
                <div>

                  {user?.linkedin_url &&
                  <a href={user.linkedin_url} target="_blank" rel="noopener noreferrer"
                    className="btn btn-secondary">
                    <Linkedin fill="white"/>
                  </a>
                  }
                </div>
              </div>
                }
                <div className={`row user-infos ${isAdmin ? '' : 'top-rounded'}\``}>
                  <div className={`col-sm-2 ${isAdmin ? 'col-md-2' : 'col-md-4'}`}>
                    <Picture
                      src={this.state.anonymized ? AnonymizedImg : image}
                      alt={altImage}
                      isReviewed={isReviewed && isAdmin}
                      isGold={user?.gold}
                      className="picture"/>
                  </div>
                  <div className={`col-sm-10 ${isAdmin ? 'col-md-10' : 'col-md-8'} m-auto`}>
                    <div className="d-flex flex-wrap align-items-end">
                      <p className="name">
                        { !this.state.anonymized ? (
                          <>
                            { user?.firstname ?? '' } { isAdmin || [sharedConf.accountTypes.do, sharedConf.accountTypes.ssii].includes(user.account_type) ? <span className="no-print">{user?.lastname ?? ''}</span> : '' }
                            { isAdmin ? <Copy className="copy no-print" size={20} onClick={this.copyFullnameToClipboard}/> : '' }
                          </>
                        ) : '' }
                        { isAdmin ? <span className="id">(#{freelance?.id ?? 0})</span> : '' }
                      </p>
                      <CompanyType user={user} className="company_type"/>
                      <div className="ml-auto price no-print">
                        <Price freelance={freelance}/>
                      </div>

                      <div className={`col-sm-3 ml-auto align-self-center print`}>
                        <LogoText className="logoText"/>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap align-items-center">
                      <h1 className="title">{title}</h1>
                      <div className="ml-auto location no-print">
                        {user?.city?.label ?? ''} {user?.relocation ? '+ France' : ''}
                      </div>
                    </div>
                    <div className="fonctions">
                      <Skills list={freelance?.fonctions?.length ? freelance.fonctions : []}/>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="summary">
                      {(freelance?.summary ?? '').split("\n").map((i, id) => {
                        if (currentUserCanView) {
                          return <span key={`summary-${id}`}>{i}<br/></span>;
                        } else if (id === 0) {
                          let line = i;
                          const maxChar = 150;
                          return <span className="fade-summary" key={`summary-${id}`}>{(line.length > maxChar ? `${line.substring(0, maxChar)}...` : line)}<br/></span>;
                        }  else {
                          return '';
                        }
                      })}
                    </div>
                  </div>
                </div>
                <div className="row bg-gray-100 disponibility no-print justify-content-center">
                  {user?.firstname ?? ''} est disponible&nbsp;
                  <span className="when"><Availability freelance={freelance}/></span>
                  {currentUser ?
                    (!isOwner &&
                    <Dropdown isOpen={this.state.contactDropDownOpen} toggle={this.toggleContact}>
                      <DropdownToggle caret color="secondary">
                        Contacter
                      </DropdownToggle>
                      <DropdownMenu className={this.state.contactDropDownOpen ? 'show' : ''}>
                        <DropdownItem key="0"
                          onClick={() => this.openContactModal(user, freelance)}>Contacter</DropdownItem>
                        {isAdmin ?
                          <div>
                            {freelance.cv && freelance.cv.original &&
                            <DropdownItem key="1">
                              <a href={freelance.cv.original} target="_blank" rel="noopener noreferrer">
                                Télécharger le CV Original
                              </a>
                            </DropdownItem>
                            }
                            {freelance.skills_file && freelance.skills_file.original &&
                            <DropdownItem key="2">
                              <a href={freelance.skills_file.original} target="_blank" rel="noopener noreferrer">
                                Télécharger le DC uploadé
                              </a>
                            </DropdownItem>
                            }
                            <DropdownItem key="3" onClick={() => this.onCvNormalizedDownloaded(false)}>
                              Télécharger le dossier de compétences
                            </DropdownItem>
                            <DropdownItem key="3" onClick={() => this.onCvNormalizedDownloaded(true)}>
                              Télécharger le DC anonymisé
                            </DropdownItem>
                          </div>
                          :
                          <DropdownItem key="1" onClick={() => this.onCvNormalizedDownloaded(false)}>
                            Télécharger le dossier de compétences
                          </DropdownItem>
                        }
                      </DropdownMenu>
                    </Dropdown>
                    )
                  ||
                  (
                    <button className="btn btn-primary" onClick={() => this.onCvNormalizedDownloaded(false)}>
                      Télécharger mon dossier de compétences
                    </button>
                  ) : (
                      <button className="btn btn-primary"
                        onClick={() => this.openContactModal(user, freelance)}>
                      Contacter
                      </button>
                    )
                  }
                  {!currentUser || currentUserCanView ? '' :
                    <div className="col-12 justify-content-center">
                      <Badge color="warning">
                      Attention vous devez encore valider votre adresse mail pour avoir accès aux profils à 100%.
                      </Badge>
                    </div>
                  }
                </div>
              </div>
            </div>

            {isReviewed &&
              <div className="row bordered break-after">
                <div className="col-12">
                  <Review
                    className="reviews box"
                    freelance={freelance}
                    reviews={reviews}
                    human_skills={human_skills}
                    title={true}
                  />
                </div>
              </div>
            }

            <div className={"row expertises-secteurs bordered"}>
              <div className="col expertises print-no-border">
                <div className="row box">
                  <div className="col-lg-12">
                    <h2 className="sub-title break-inside">
                      {this.props.expertisesTitle}
                    </h2>

                    <Skills
                      key={freelance.id}
                      list={(freelance?.master_skills?.length ? freelance.master_skills : []).concat(freelance?.expertises?.length ? freelance.expertises : [])}
                    />
                  </div>
                </div>
              </div>

              <div className="col secteurs print-no-border page-break-inside">
                <div className="row box">
                  <div className="col-lg-12">
                    <h2 className="sub-title break-inside">
                      {this.props.secteursTitle}
                    </h2>

                    <Skills
                      key={freelance.id}
                      list={freelance?.secteurs?.length ? freelance.secteurs : []}
                    />
                  </div>
                </div>
              </div>
            </div>

            {currentUserCanView ?
              <Fragment>
                <div className="row bordered break-after">
                  <div className="col-12">
                    <div className="row missions-summary box">
                      <div className="col-lg-12">
                        <h2 className="sub-title break-inside">
                          {this.props.missionsSummaryTitle}
                        </h2>

                        <MissionSummary
                          className="tick-tack"
                          freelance={freelance}
                          canEdit={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row bordered missions-container break-after">
                  <div className="col-12">
                    <div className="row missions box">
                      <div className="col-lg-12">
                        <h2 className="sub-title break-inside">
                          {this.props.missionsTitle}
                        </h2>

                        <Mission
                          className="tick-tack"
                          freelance={freelance}
                          canEdit={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="row bordered">
                  <div className="col-12">
                    <div className="row parcours-list box page-break-inside">
                      <div className="col-lg-12">
                        <h2 className="sub-title break-inside">
                          {this.props.parcoursTitle}
                        </h2>

                        {(freelance?.diplomes?.length ? freelance.diplomes : []).map((diplome, offset) => (
                          <div className="tick-tack page-break-inside" key={`diplome-${offset}`}>
                            {(diplome.name || diplome.year) &&
                          <div>
                            {diplome.name && <b>{diplome.name}</b>}
                            {diplome.name && diplome.year && <span> - </span>}
                            {diplome.year && <MomentDate format="yyyy" date={diplome.year}/>}
                          </div>
                            }
                            <div className={(diplome.name) ? 'mt-2' : ''}>
                              {nl2br(diplome.description)}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <CardRow className="row certs-languages page-break-inside">
                      <CardCol flex={1} className={`col-certs box ${`col-certifications ${freelance?.certifications?.length ? '' : 'no-print'}`}`}>
                        <h2 className="sub-title break-inside">
                          {this.props.certificationsTitle}
                        </h2>

                        <div>
                          {(freelance?.certifications?.length ? freelance.certifications : []).map((certification) => (
                            <div  key={`certification-${certification.id}`} className="callout callout-secondary d-inline-block mr-3 mt-0 mb-3 break-inside">
                              <b>{certification?.label}</b>
                              {certification.date && <span> - <MomentDate format="yyyy" date={certification.date}/></span>}
                            </div>
                          ))}
                        </div>
                      </CardCol>

                      <CardCol flex={1} className={`col-languages box page-break-inside ${freelance?.languages?.length ? '' : 'no-print'}`}>
                        <h2 className="sub-title break-inside">
                          {this.props.languagesTitle}
                        </h2>

                        <div>
                          {(freelance?.languages?.length ? freelance.languages : []).map((language, index) => (
                            <div key={`language-${index}`} className="callout callout-secondary d-inline-block mr-3 mt-0 mb-3 break-inside">
                              <b>{language.name}</b> - {this.state.languageLevels[language.level]}
                            </div>
                          ))}
                        </div>
                      </CardCol>

                      <CardCol flex={1} className={`col-it-skills box page-break-inside ${freelance?.it_skills?.length ? '' : 'no-print'}`}>
                        <h2 className="sub-title break-inside">
                          {this.props.itSkillsTitle}
                        </h2>

                        <div>
                          {(freelance?.it_skills?.length ? freelance.it_skills : []).map((skill, index) => (
                            <div key={`skill-${index}`} className="callout callout-secondary d-inline-block mr-3 mt-0 mb-3 break-inside">
                              <b>{skill.name}</b>
                            </div>
                          ))}
                        </div>
                      </CardCol>
                    </CardRow>
                  </div>
                </div>
              </Fragment> :
              <div className="row fade-gradient"/>
            }
          </div></FreelancePage>
        {!currentUser ? <SubscribeBanner target="freelances"/> : ''}
      </div>
    );
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
  })
)(connectModal({ContactModal}, LoadedFreelance));
